if (window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations()
    .then(registrations => {
      // eslint-disable-next-line no-restricted-syntax
      for (const registration of registrations) registration.unregister();
    });
}

if ('caches' in window) {
  caches.keys()
    .then(keyList => Promise.all(keyList.map(key => caches.delete(key))));
}
